import { render, staticRenderFns } from "./PassLogin.vue?vue&type=template&id=4e8ca543&scoped=true"
import script from "./PassLogin.vue?vue&type=script&lang=js"
export * from "./PassLogin.vue?vue&type=script&lang=js"
import style0 from "./PassLogin.vue?vue&type=style&index=0&id=4e8ca543&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8ca543",
  null
  
)

export default component.exports